// Форматирование записей API-ответов: строки дат → Date, числовые id → int.
// Доп. поля сущности — через static CustomItem(data) в наследнике.
export default class Formatter {
    // Геттер, а не метод: Api-класс присваивает formatterItem = Formatter.Item,
    // this внутри стрелки — класс-наследник (его CustomItem и подхватится).
    static get Item() {
        return (data) => ({
            ...data,
            id: this.Int(data.id),
            created_at: this.Date(data.created_at),
            updated_at: this.Date(data.updated_at),
            ...this.CustomItem(data),
        });
    }

    // Переопределяется в наследниках для доп. полей-дат/чисел.
    static CustomItem(data) {
        return {};
    }

    static Int(value) {
        if (value === undefined || value === null || value === '') return null;
        const number = parseInt(value, 10);
        return isNaN(number) ? null : number;
    }

    static Date(value) {
        if (!value) return null;
        const date = new Date(value);
        return isNaN(date.getTime()) ? null : date;
    }
}
